import { render, staticRenderFns } from "./NewSubpoena.vue?vue&type=template&id=3179041a&"
import script from "./NewSubpoena.vue?vue&type=script&lang=js&"
export * from "./NewSubpoena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports